export enum AccountCategoryCode {
  External = 'ext',
  ExternalTrial = 'ext-trial',
  InternalRnd = 'int-rnd',
  InternalOps = 'int-ops',
  InternalCommercial = 'int-com',
  PartnerTrial = 'par-trial',
  DeletedOnly = 'deleted',
  DemoB2bService = 'demo-service',
  DemoExperienceTransportation = 'demo-transp',
  DemoMembershipOrg = 'demo-membership',
  DemoB2BProduct = 'demo-product',
  Trial = 'trial',
  SuiteMaxo = 'suite-maxo',
}

export interface AccountCategory {
  id: number;
  code: AccountCategoryCode;
  displayName: string;
}
